
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import JsonItemsHelpDialog from '../infoDialogs/DatasetManagementJsonPathItemsInfoDialog.vue'
import DirectAttributesHelpDialog from '../infoDialogs/DatasetManagementAttributesDirectInfoDialog.vue'
import NgsiHelpDialog from '../infoDialogs/DatasetManagementNgsiInfoDialog.vue'
import RequestHeadersTable from '../tables/DatasetManagementRequestHeadersTable.vue'
import JsonPathTable from '../tables/DatasetManagementJsonPathAttributesTable.vue'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import restDescriptor from './DatasetManagementRestDatasetDescriptor.json'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'

export default defineComponent({
    components: { Card, Dropdown, KnValidationMessages, RequestHeadersTable, JsonPathTable, Checkbox, JsonItemsHelpDialog, DirectAttributesHelpDialog, NgsiHelpDialog },
    props: { selectedDataset: { type: Object as any } },
    emits: ['touched'],
    data() {
        return {
            restDescriptor,
            dataset: {} as any,
            v$: useValidate() as any,
            ngsiHelpVisible: false,
            jsonItemsHelpVisible: false,
            directAttributesHelpVisible: false,
            httpMethods: restDescriptor.httpMethods
        }
    },
    created() {
        this.setDatasetToComponent()
    },
    watch: {
        selectedDataset() {
            this.setDatasetToComponent()
        }
    },
    validations() {
        const restFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'REST' || value
        }
        const customValidators: ICustomValidatorMap = { 'rest-fields-required': restFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', restDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        setDatasetToComponent() {
            this.dataset = this.selectedDataset

            this.dataset.restDirectlyJSONAttributes = this.dataset.restDirectlyJSONAttributes.toLowerCase() === 'true'
            this.dataset.restNGSI = this.dataset.restNGSI === 'true'
        }
    }
})
